import { Title } from '@panwds/react-ui'
import { PanWLogoWithText } from '../../activation/assets'

export interface ScreenHeaderProps {
  title: string;
}
const ScreenHeader = (props: ScreenHeaderProps) => {
  const { title } = props

  return (
    <div className='cm-fixed cm-top-0 cm-left-0 cm-w-full cm-px-20 cm-z-50 cm-flex cm-justify-center'>
      <div className='cm-w-[1000px]'>
        <div className='cm-bg-white cm-pt-10'>
          <img className='cm-w-[132px]' alt={'logo'} src={PanWLogoWithText} />
          <Title addClassName='cm-flex' level={1} size={'sm'}>
            {title}
          </Title>
        </div>
        <div className='cm-w-[1000px] cm-h-5 cm-bg-gradient-to-b cm-from-white cm-to-transparent'></div>
      </div>
    </div>
  )
}
export default ScreenHeader
